import { render, staticRenderFns } from "./queryFlowDirectionNew.vue?vue&type=template&id=95d1fff8"
import script from "./queryFlowDirectionNew.vue?vue&type=script&lang=js"
export * from "./queryFlowDirectionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports